import { type Context, createContext, type Provider, useContext } from 'react';

import type { AgentVersioningConfig } from '../../types';

const agentVersioningConfigContext: Context<AgentVersioningConfig | undefined> = createContext<
	AgentVersioningConfig | undefined
>(undefined);

export const useAgentVersioningConfig = (): AgentVersioningConfig | undefined =>
	useContext(agentVersioningConfigContext);

export const AgentVersioningConfigProvider: Provider<AgentVersioningConfig | undefined> =
	agentVersioningConfigContext.Provider;
